import dayjs from 'dayjs'

//
// Get offers in custom order from FAT response
//
export function useOffersFromFat(restaurants) {
  if (!restaurants?.length) return []
  const allMeals = useOffersExtractAllMeals(restaurants)
  const allMealsSorted = useOffersSortAllMeals(allMeals)
  const uniqueMeals = useUniqueBy(allMealsSorted, 'restaurantId')
  const promotedMeals = useOffersPromotedMeals(uniqueMeals)
  return promotedMeals
}

// 
// Extract meals and attach restaurant info
//
export function useOffersExtractAllMeals(restaurants) {
  return restaurants?.flatMap(restaurant => 
    restaurant?.meals?.map(meal => ({
      id: meal.id,
      restaurantId: restaurant.id,
      ...meal,
      restaurant: {
        ...restaurant,
        meals: undefined
      }
    })))
}

// 
// Get selected meals in custom order based on all meals
//
export function useOffersSortAllMeals(meals) {
  // Define the custom sort order (table today, standard, early bird)
  const sortOrder = { 3: 1, 1: 2, 2: 3 }

  // Sort meals first by altType, then by restaurant rank within each altType group
  return meals.sort((a, b) => {
    // First, sort by altType using predefined sortOrder
    const altTypeComparison = sortOrder[a.altType] - sortOrder[b.altType]

    // If altType is the same, sort by restaurant rank descending
    if (altTypeComparison === 0) {
      return b.restaurant.rank - a.restaurant.rank
    }

    return altTypeComparison
  })
}

//
// Get promoted meals
//
export function useOffersPromotedMeals(uniqueMeals) {
  const isPromotionValid = (promotion) => {
    if (!promotion) return false
    const now = dayjs().format('YYYY-MM-DD')
    const hasStarted = dayjs(promotion.startDate).isSameOrBefore(now)
    const hasNotEnded = dayjs(promotion.endDate).isSameOrAfter(now)
    return promotion.promotionTypes.includes('offers') && hasStarted && hasNotEnded
  }

  const promotedMeals = []

  // Loop over uniqe meals and push every meal to promotedMeals 
  uniqueMeals.forEach(meal => {
    const { restaurant } = meal
    const { promoted } = restaurant

    // Check if the meal has a valid promotion
    if (isPromotionValid(promoted)) {
      const insertPosition = promoted.rank - 1 // Convert to zero-based index

      // Insert promoted meal at the defined position if it's within bounds
      if (insertPosition >= 0 && insertPosition < promotedMeals.length) {
        promotedMeals.splice(insertPosition, 0, meal)
      } else {
        promotedMeals.push(meal) // If position is out of range, push it at the end
      }
    } else {
      promotedMeals.push(meal) // Regular meal, just push it
    }
  })

  return promotedMeals
}